import { TEAM_MANAGED_PROJECT } from '@atlassian/jira-common-constants';
import {
	LIMITED_ACCESS_LEVEL,
	PRIVATE_ACCESS_LEVEL,
	type AccessLevel,
} from '@atlassian/jira-shared-types';
import { ProjectTypes, TemplateTypes } from '../../../common/constants/project';
import type { CreateProjectConfig, ProjectData } from '../../../common/types';

const accessLevels: AccessLevel[] = [LIMITED_ACCESS_LEVEL, PRIVATE_ACCESS_LEVEL];

export const validateFile = async (file: File) => {
	try {
		const fileContent = await file.text();
		const config = JSON.parse(fileContent);
		if (
			'projectData' in config &&
			typeof config.projectData === 'object' &&
			'fieldMappings' in config &&
			typeof config.fieldMappings === 'object'
		) {
			return config.projectData;
		}
		return null;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		return null;
	}
};

export const transformToValidProjectData = (
	data: ProjectData,
	projectSettings: CreateProjectConfig[],
) => {
	const projectData: ProjectData = {
		type: null,
		style: null,
		template: null,
		accessLevel: null,
		name: '',
		key: '',
	};

	const supportedTypes = projectSettings.map((setting) => setting.productType);
	if (supportedTypes.some((supportedType) => supportedType === data.type)) {
		projectData.type = data.type;
	}

	const supportedStyles =
		projectSettings.find((setting) => setting.productType === data.type)?.projectStyles || [];
	if (supportedStyles.some((supportedStyle) => supportedStyle === data.style)) {
		projectData.style = data.style;
	}

	if (
		projectData.type === ProjectTypes.SOFTWARE &&
		Object.values(TemplateTypes).some((supportedTemplate) => supportedTemplate === data.template)
	) {
		projectData.template = data.template;
	}

	if (
		projectData.style === TEAM_MANAGED_PROJECT &&
		accessLevels.some((supportedLevel) => supportedLevel === data.accessLevel)
	) {
		projectData.accessLevel = data.accessLevel;
	}

	return projectData;
};
